package com.karyadina.ui.util

actual object PlatformLocale {
    actual fun changeLanguage(language: String) {
        // JS Locale change is usually browser-managed or requires reload.
        // No-op for now.
    }
}
